module.exports = __webpack_public_path__ + "media/music/da3126c6a70c4ef84192c33f99996354.mp3";